<template>
  <div class="page-ranking">
		<div class="ranking-center">
			<div class="ranking-body flex-row">
				<div class="body-item guess_list">
					<RankingList 
						:type="3" 
						:needFocusBtn="false" ></RankingList>
				</div>
				<div class="body-item zb">
					<RankingList 
						:type="1" 
						:needFocusBtn="true" ></RankingList>
				</div>
				<div class="body-item dr">
					<RankingList
						:type="2" 
						:needFocusBtn="false" ></RankingList>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
import { post } from "../../util/http";
import { mapState,mapMutations } from "vuex";
import Footer from "@/components/footer/footer";
import RankingList from "@/components/ranking-list/ranking-list"
export default {
	components: {
		RankingList,
		Footer
	},
	 watch: {
		"appConfig.talent_list_status": {
		　　 handler(n, o){
			　　if(n!=1){
						this.$router.push("/");
						return;
					}
		　　},
		　　immediate: false
		}
	},
	computed: {
	  ...mapState(["userInfo","appConfig"]),
	},
  data() {
    return {
		
    };
  },
  async created() {
	
  },
	mounted(){
		
	},
	destroyed(){
		
	},
  methods: {
		...mapMutations(["changeUserInfo", "toggleLogin", "changeLoginType"]),

	}
};
</script>

<style lang="scss" scoped>
.page-ranking {
  margin-top: .5rem;

  // margin-bottom: 16px;
  // background: #ffffff;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.1);
	background: url(./img/rk-bg.png) no-repeat;
	background-position: center top;
	background-size: 100% auto;
  // border-radius: .16rem;
  // padding: .4rem;
	.ranking-center{
		width: 14rem;
		margin: 0 auto;
		margin-top: 2.4rem;
		margin-bottom: .1rem;
		padding: .05rem;
		border-radius: .2rem;
		overflow : hidden;
		background: rgba(255, 255, 255, .8);
	}
	.ranking-body{
		justify-content: space-between;
		min-height : 5rem;
		border-radius: .2rem;
		overflow : hidden;
		background-color : #ffffff;
		.body-item{
			width : 4.5rem;
			background-repeat: no-repeat;
			background-position : center top;
			background-size : 100% auto;
			&.guess_list{
				background-image: url(./img/b-3.png);
			}
			&.zb{
				background-image: url(./img/b-1.png);
			}
			&.dr{
				background-image: url(./img/b-2.png);
			}
		}
		
	}
	.ranking-footer{
		font-size : .15rem;
		line-height : .25rem;
		color : #666666;
		padding : .2rem .4rem;
		background: #ffffff;
	}

}
</style>
